export default "__VITE_ASSET__GbhmhU1P__"